import React, { useState } from 'react'
import styled from 'styled-components'
import { Tabs, Tab, H3 } from 'ui/bend'
import { Flex } from 'ui/acro'
import ClassFinder from '../classFinder/ClassFinder'
import ExplorePage from '../explore/ExplorePage'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'

const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
`

const InstructorContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
  gap: 32px;
  .GreyPageHeader {
    display: none;
  }
  .ExploreFilterPage {
    padding: 0;
  }
`

const StyledTab = styled(Tabs)`
  width: auto;
  justify-content: center;
  ::before {
    background: none;
  }
`
const H3Tag = styled(H3)`
  color: ${(props) => props.theme.colors.primary};
  text-transform: uppercase;
  font-size: 24px;
  line-height: 135%;
  letter-spacing: -0.72px;
  ${(props) => props.theme.mediaQueries.medium} {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.96px;
  }
`

const InstructorPage = (props) => {
  const [selectedTab, setSelectedTab] = useState('classes')
  const handleClick = (tab) => {
    setSelectedTab(tab)
  }
  return (
    <ThemeProvider theme={LightTheme}>
      <Container>
        <H3Tag>{props.instructorFirstName}'s Classes & Programs</H3Tag>
        <InstructorContainer>
          <StyledTab id='my_practice_tabs'>
            <Tab
              id='1'
              title='Classes'
              style={{
                flex: 1
              }}
              active={selectedTab === 'classes'}
              onClick={() => {
                handleClick('classes')
              }}
            >
              {selectedTab === 'classes' ? <ClassFinder {...props} /> : null}
            </Tab>
            <Tab
              id='3'
              title='Programs'
              style={{ flex: 1 }}
              active={selectedTab === 'series'}
              onClick={() => {
                handleClick('series')
              }}
            >
              {selectedTab === 'series' ? (
                <ExplorePage
                  {...props}
                  equipmentTags={props.planEquipmentTags}
                  focusAreaTags={props.planFocusAreaTags}
                />
              ) : null}
            </Tab>
          </StyledTab>
        </InstructorContainer>
      </Container>
    </ThemeProvider>
  )
}

export default InstructorPage
